import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  width: 60px;
  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.5), 0 0 8px 3px rgba(0, 0, 0, 0.05);
  background-color: var(--panels-bk-color);
  border-radius: 10px 0 0 10px;
  padding: 10px 0;
  border: 1px solid #334;
  gap: 1px;
`;
